import mogoButton from './mogoButton.component';

export default angular
  .module('st.Integrations.Mogo', ['st.Core', 'angular-cache'])
  .component('mogoButton', mogoButton)
  .service('mogoService', ($http, dataService, MOGO) => ({
    emailInvite: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, MOGO.API.MAIL_INVITE, params)
  }))
  .constant('MOGO', {
    API: {
      MAIL_INVITE: '/api/v1/integrations/mogo/email-invite'
    }
  });
